import { render } from "./BillingPayment.vue?vue&type=template&id=937e92a6&scoped=true&ts=true"
import script from "./BillingPayment.vue?vue&type=script&lang=ts"
export * from "./BillingPayment.vue?vue&type=script&lang=ts"

import "./BillingPayment.vue?vue&type=style&index=0&id=937e92a6&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937e92a6"]])

export default __exports__